module.exports = __webpack_public_path__ + "static/img/icon_s.9bd59d0.png";